/**
 * Editor command bus — menubar / shortcuts call into the live Fabric editor.
 */

export type EditorCommandId =
  | 'save'
  | 'export'
  | 'present'
  | 'close'
  | 'undo'
  | 'redo'
  | 'cut'
  | 'copy'
  | 'paste'
  | 'duplicate'
  | 'select-all'
  | 'delete'
  | 'group'
  | 'ungroup'
  | 'bring-front'
  | 'bring-forward'
  | 'send-backward'
  | 'send-back'
  | 'flip-h'
  | 'flip-v'
  | 'rotate-cw'
  | 'rotate-ccw'
  | 'align-left'
  | 'align-center'
  | 'align-right'
  | 'align-top'
  | 'align-middle'
  | 'align-bottom'
  | 'toggle-rulers'
  | 'toggle-libraries'
  | 'toggle-inspector'
  | 'toggle-grid'
  | 'zoom-in'
  | 'zoom-out'
  | 'zoom-100'
  | 'artboard-size'
  | 'shortcuts'
  // motion editor
  | 'toggle-motion-mode'
  | 'video-export'
  | 'video-play-pause'
  | 'video-stop'
  | 'scene-add'
  | 'scene-duplicate'
  | 'scene-delete'
  | 'animation-panel';

type EditorCommandHandler = () => void | Promise<void>;

const handlers = new Map<EditorCommandId, EditorCommandHandler>();

export function registerEditorCommand(
  id: EditorCommandId,
  handler: EditorCommandHandler | null
): void {
  if (handler) handlers.set(id, handler);
  else handlers.delete(id);
}

export function registerEditorCommands(
  map: Partial<Record<EditorCommandId, EditorCommandHandler | null>>
): void {
  (Object.keys(map) as EditorCommandId[]).forEach((id) => {
    registerEditorCommand(id, map[id] ?? null);
  });
}

export function runEditorCommand(id: EditorCommandId): boolean {
  const handler = handlers.get(id);
  if (!handler) return false;
  void handler();
  return true;
}

export function clearEditorCommands(): void {
  handlers.clear();
}
